import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../reducers/types";
import {
  deleteUserPassenger,
  fetchCorpUserPassengers,
  fetchUserPassengers,
  setUserSelectedPassengerIds,
  updateUserPassenger,
} from "../../../actions/actions";
import {
  getIsMissingLicense,
  getUserPassengerCallState,
  getUserPassengers,
  getUserSelectedTravelerId
} from "../../../reducer";
import { getCorporateInfo } from "../../../../rewards/reducer/selectors";
import { MobileBookDriverSelection } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    travelers: getUserPassengers(state),
    userPassengerCallState: getUserPassengerCallState(state),
    selectedTravelerId: getUserSelectedTravelerId(state),
    isMissingLicense: getIsMissingLicense(state),
    userRoles: getCorporateInfo(state)?.role,
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileBookDriverSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileBookDriverSelection = connector(
  MobileBookDriverSelection
);
